export enum FeedbackClassification {
    Bug = 'Bug',
    Compliment = 'Compliment',
    FeatureRequest = 'FeatureRequest',
}
